<template>
	<router-link :to="linkUrl">
		<v-img
			:src="imageSrc"
			lazy-src="//image.gsshop.com/ui/gsshop/mc/product/images/thumb_noimg_300.jpg"
			class="lighten-2"
			transition="fade-transition"
			aspect-ratio="1"
			justify="bottom"
		>
			<v-icon v-if="videoFlag" class="btn-video-play-sm">mdi-play</v-icon>
			<template v-slot:placeholder>
				<v-row class="fill-height ma-0" align="center" justify="center">
					<v-progress-circular
						indeterminate
						color="grey lighten-5"
					></v-progress-circular>
				</v-row>
			</template>
		</v-img>
	</router-link>
</template>

<script>
import store from "@/store";

export default {
	name: "Thumbnail",
	props: {
		index: Number,
		item: Object,
	},
	computed: {
		imageSrc() {
			return "IMAGE" == this.item.type
				? this.item.thumbPath
				: this.item.thumbPath.replace(
						"/user/thumb/100/",
						"/user/thumb/150/"
				  );
		},
		videoFlag() {
			return "VIDEO" == this.item.type;
		},
		linkUrl() {
			return (
				"/thumblist/" +
				store.state.prdcd +
				"/" +
				(this.index + 1) +
				"?mseq=430459"
			);
		},
	},
};
</script>

<style lang="scss">
.btn-video-play-sm {
	position: absolute !important;
	bottom: 8px;
	left: 8px;
	width: 28px;
	height: 28px;
	border-radius: 50%;
	background: rgba(25, 25, 35, 0.32);
	text-decoration: none;
	.mdi-play::before {
		content: "";
	}
	color: #fff !important;
}
.v-image__image--preload {
	filter: blur(0);
}
</style>